import React from "react";
import { connect } from "react-redux";
import { number, string, object, array, func, oneOfType } from "prop-types";
import { emailCandidates, inviteCandidate } from "../actions";
import EmailCandidatesComponent from "../actionComponents/EmailCandidatesComponent";

const EmailCandidates = (props) => {
  const {
    savedEmailTemplates,
    callLocation,
    changeAction,
    candidateIds,
    candidateName,
    testEventId,
    onEmailCandidates,
    onInviteCandidate,
  } = props;

  return (
    <EmailCandidatesComponent
      callLocation={callLocation}
      candidateIds={candidateIds}
      savedEmailTemplates={savedEmailTemplates}
      onEmailCandidates={onEmailCandidates}
      onInviteCandidate={onInviteCandidate}
      changeAction={changeAction}
      candidateName={candidateName}
      testEventId={testEventId}
    />
  );
};

EmailCandidates.propTypes = {
  savedEmailTemplates: object,
  callLocation: string,
  changeAction: func,
  candidateIds: array,
  candidateName: string,
  testEventId: oneOfType([number, string]),
  onEmailCandidates: func,
  onInviteCandidate: func,
};

const mapStateToProps = (state) => ({
  savedEmailTemplates: state.get("results").get("savedEmailTemplates"),
});

const mapDispatchToProps = (dispatch) => ({
  onEmailCandidates: (dataObj) => dispatch(emailCandidates(dataObj)), // {emailTemplateId: '', testTakerIds: []};
  onInviteCandidate: (testEventId, candidateName) =>
    dispatch(inviteCandidate(testEventId, candidateName)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailCandidates);
